export const TASK_STATUS = {
  0: { text: '未执行', color: 'info' },
  1: { text: '执行中', color: 'warning' },
  2: { text: '已执行', color: 'success' },
  '-1': { text: '已删除', color: 'danger' }
};

export const TASK_BALANCE_TYPE = [
  { value: 1, label: '可用余额' },
  // { value: 2, label: '杠杆可用' },
  { value: 0, label: '冻结余额' },
  // { value: -1, label: '交易冻结' },
  // { value: -2, label: '申购冻结' },
  // { value: -3, label: '提现冻结' },
  // { value: -4, label: '锁仓冻结' },
  // { value: -5, label: '武侠冻结' },
  // { value: -6, label: '存币生息冻结' },
  // { value: -7, label: '杠杆冻结' },
  // { value: -9, label: 'C2C交易冻结' }
];

export const TASK_TYPE = [
  { value: 'USER_AIRDROP_AWARD', label: '空投奖励' },
  { value: 'USER_AIRDROP_ROLLBACK', label: '空投回滚' }
];

export const RECORD_STATUS = {
  0: { text: '未发放', color: 'info' },
  1: { text: '已发放', color: 'success' },
  '-1': { text: '已删除', color: 'danger' }
};

export const PAGINATION = {
  page: 1,
  size: 25
};
